module.exports = __webpack_public_path__ + "static/media/contact.8ed00d69.png";